import {defineStore,} from 'pinia'

export const useConsentStore = defineStore('consent', {
    state: () => ({
        consent: {},
    }),
})
